module.exports = "/img/_/_/_/assets/images/creeper/book/epic//7.jpg?b4a0dd4e4a4555d60af7e2db1aa6b45b";